'use client'

import classnames from 'classnames'
import styles from './PhotoTextCarouselItem.module.scss'
import SanityImage from '@/components/SanityImage/SanityImage'

type PhotoTextCarouselItemProps = SanityPhotoTextCarouselItem & {
  className?: string
}

const PhotoTextCarouselItem = ({
  className,
  image,
  quote,
  authorName,
  authorRole,
}: PhotoTextCarouselItemProps) => {
  const hasImage = image?.asset?.url

  if (!quote || !authorName) {
    return null
  }

  return (
    <div className={classnames(styles.PhotoTextCarouselItem, className)}>
      <div className={styles.inner}>
        <div className={styles.imageSide}>
          <div className={styles.imageContainer}>
            {hasImage && (
              <SanityImage
                className={styles.image}
                image={image}
                breakpoints={{
                  tablet: {
                    width: 800,
                    image,
                  },
                  xs: {
                    width: 500,
                    image,
                  },
                }}
              />
            )}
          </div>
        </div>
        <div className={styles.textSide}>
          <div className={styles.text}>
            <blockquote className={styles.quote}>
              {quote}
            </blockquote>
            <p className={styles.author}>
              {authorName}
              {authorRole && `, ${authorRole}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

PhotoTextCarouselItem.displayName = 'PhotoTextCarouselItem'

export default PhotoTextCarouselItem
